import { useMount } from 'react-use';

import { useUserAuth } from '@bedc/client/auth/hooks';
import { LoadingSpinner } from '@bedc/client/components/controls/misc/LoadingSpinner';
import { clientConstants } from '@bedc/client/constants';

/**
 * Logout page component.
 *
 * This page needs to exist as Cognito requires a redirect page after logout
 * and does not allow / to be used.
 */
export const LogoutPage = () => {
	// Hooks
	// ------------------------------------------------------------------------

	const { logout } = useUserAuth();

	// Effects
	// ------------------------------------------------------------------------

	useMount(async () => {
		try {
			await logout();
		} catch {
			// Return the user to the login page.
			window.location.href = clientConstants.auth.LoginPath;
		}
	});

	// Template
	// ------------------------------------------------------------------------

	return <LoadingSpinner />;
};
